export default __webpack_public_path__ + "static/media/bicycle20000.70df6abe.jpg";